import React, { useState, useEffect } from "react";
import { title } from "../../text/page-title.text";
import { msg } from "../../text/form-message.text";
import { button } from "../../text/button.text";
import { useNavigate } from "react-router-dom";
import { formTitle } from "../../text/form-title.text";
import {
  Button,
  Title,
} from "@creditonebank/c1b-components";
import { LoaderComponent } from "../../components/loader/loader.component";
import { BackToSignIn } from "../../components/link/back-to-signin.component";
import { HelpLink } from "../../components/link/help-link.component";
import { href } from "../../utils/ui-urls";

const PasswordChangeRequired = ({ signInUrl, helpLink }) => {
  useEffect(() => {
    document.title = title.passwordChangeRequired;
    window.scrollTo(0, 0);
  }, []);

  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();

  function handleSubmit(e) {
    navigate(href.verifyUser);
  }

  return (
    <div className="bg">
      {showLoader ? (
        <LoaderComponent />
      ) : (
        <div className="form-element-short">
          <form onSubmit={(e) => handleSubmit(e)} className="fp-form">
            <div className="title">
              <Title tag="h2" className="web-title">
                {formTitle.passwordChangeRequired}
              </Title>

              <Title tag="h2" className="mobile-title" align="left">
                {formTitle.passwordChangeRequired}
              </Title>
            </div>

            <div className="description">
                <p className="description-message">
                    {msg.passwordChangeRequired}
                </p>
            </div>

            <Button
              type="submit"
              onClick={handleSubmit}
              size="medium"
              className="button-style-fp"
              id="passwordChangeRequiredButton"
            >
              {button.passwordChangeRequired}
            </Button>

            <div className="centre-align inside-box2">
              <BackToSignIn signInUrl={signInUrl} />
            </div>
          </form>
        </div>
      )}

      <div className="centre-align out-of-box">
        <HelpLink helpLink={helpLink} />
      </div>
    </div>
  );
};

export default PasswordChangeRequired;
